export function FormField({ id, label, error, hint, testId, optional = false, ...inputProps }) {
  const describedBy = [error && `${id}-error`, hint && `${id}-hint`].filter(Boolean).join(" ") || undefined;
  return (
    <div className="space-y-2">
      <label htmlFor={id} className="mw-eyebrow flex items-center justify-between">
        <span>{label}</span>
        {optional && <span className="normal-case tracking-normal text-muted-foreground/70">Optional</span>}
      </label>
      <input
        id={id}
        data-testid={testId}
        aria-invalid={Boolean(error)}
        aria-describedby={describedBy}
        className={`mw-input ${error ? "border-destructive focus:border-destructive" : ""}`}
        {...inputProps}
      />
      {error && (
        <p id={`${id}-error`} data-testid={`${testId}-error`} className="text-xs text-destructive">
          {error}
        </p>
      )}
      {hint && (
        <div id={`${id}-hint`} className="text-xs text-muted-foreground">
          {hint}
        </div>
      )}
    </div>
  );
}
